// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"5dde0a62","333":"e07b7769","522":"6e80b644","540":"b68c95f9","672":"ede6f704","798":"b2d21df2","828":"fae33d6e"}[chunkId] + ".chunk.js";
};